'use client';
import { Breadcrumbs } from './breadcrumbs.js';
import { BreadcrumbsItem } from './breadcrumbs-item.js';
import { BreadcrumbsLink } from './breadcrumbs-link.js';
import { BreadcrumbsList } from './breadcrumbs-list.js';

/**
 * `Breadcrumbs` is a component that displays a list of breadcrumbs.
 *
 * @example
 * <Breadcrumbs aria-label='Du er her:'>
 *  <Breadcrumbs.Link href='#' aria-label='Tilbake til Nivå 1'>
 *    Nivå 1
 *  </Breadcrumbs.Link>
 *  <Breadcrumbs.List>
 *    <Breadcrumbs.Item>
 *      <Breadcrumbs.Link href='#'>Nivå 1</Breadcrumbs.Link>
 *    </Breadcrumbs.Item>
 *    <Breadcrumbs.Item>
 *      <Breadcrumbs.Link href='#'>Nivå 2</Breadcrumbs.Link>
 *    </Breadcrumbs.Item>
 *  </Breadcrumbs.List>
 * </Breadcrumbs>
 */
const BreadcrumbsComponent = Object.assign(Breadcrumbs, {
    List: BreadcrumbsList,
    Item: BreadcrumbsItem,
    Link: BreadcrumbsLink,
});
BreadcrumbsComponent.List.displayName = 'Breadcrumbs.List';
BreadcrumbsComponent.Item.displayName = 'Breadcrumbs.Item';
BreadcrumbsComponent.Link.displayName = 'Breadcrumbs.Link';

export { BreadcrumbsComponent as Breadcrumbs, BreadcrumbsItem, BreadcrumbsLink, BreadcrumbsList };
